import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import typography from 'material-ui/styles/typography';
import { Button, Icon } from '@material-ui/core';
import { Subheader } from 'material-ui';
import RenewalsPricingInfo from './panels/RenewalsPricingInfo/RenewalsPricingInfo';
import CustomerHeader from '../../../widgets/CustomerHeader/CustomerHeader';
import { cloneDeep } from 'lodash';
import RenewalsOptionsPanel from './panels/RenewalsOptionPanel';
import { getUpdatedServiceCharge } from './panels/RenewalsPricingInfo/pricing-info-util';
import RenewalsEscalationNotePanel from './panels/RenewalsEscalationNotePanel';
import RenewalsApprovalRequiredPanel from './panels/RenewalsApprovalRequiredPanel';
import { getRenewalValidations } from '../../../../utils/renewals-util';
import PageBase from '../../../widgets/PageBase/PageBase';
import './RenewalProductListPage.css';
import * as RenewalStatus from '../../../../constants/RenewalStatus';
import RenewalLineItemListWrapper from '../../../containers/renewals/RenewalPageWrapper/RenewalLineItemListWrapper/RenewalLineItemListWrapper';
import { getBranchRole } from '../../../../utils/session-util';
import * as UserType from '../../../../constants/UserType';
import { injectIntl } from 'react-intl';
import EmblemCharges from '../../../widgets/EmblemCharges/emblemCharges';
import { RENEWAL_COOL_OFF } from '../../../../constants/CustomerStatus';
import { formatDateForDisplay } from '../../../../utils/utils';
import PictureAsPdfSharpIcon from '@material-ui/icons/PictureAsPdfSharp';
import TextField from '@material-ui/core/TextField';
import ErrorIcon from '@material-ui/icons/Error';
import { RENEWALS_PORTAL_URL } from '../../../../route-names';
import { withRouter } from 'react-router-dom';

class RenewalProductListPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      priceIncreaseValue: this.props.customer.renewalPriceIncrease,
      approvalNotes: this.props.renewal?.adjustmentReason?.reason || '',
      approvalNotesChanged: false,
      hadApprovalRequired: props.renewal?.status === RenewalStatus.APPROVAL_REQUIRED.name
    };

    this.handlePriceIncreaseChange = this.handlePriceIncreaseChange.bind(this);
    this.updateServiceCharge = this.updateServiceCharge.bind(this);
    this.submitPriceIncreaseChange = this.submitPriceIncreaseChange.bind(this);
    this.handleApprovalNotesChange = this.handleApprovalNotesChange.bind(this);
    this.handleSaveApprovalNotes = this.handleSaveApprovalNotes.bind(this);
    this.handleBackToCustomerList = this.handleBackToCustomerList.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.renewal &&
      this.props.renewal.status === RenewalStatus.APPROVAL_REQUIRED.name &&
      !this.state.hadApprovalRequired
    ) {
      this.setState({ hadApprovalRequired: true });
    }
  }

  handlePriceIncreaseChange(event) {
    const value = event.target.value;
    this.setState(
      {
        priceIncreaseValue: value
      },
      () => this.submitPriceIncreaseChange()
    );
  }

  updateServiceCharge(specialChargesKey, value, submitUpdates = true) {
    const updatedRenewal = cloneDeep(this.props.renewal);
    const serviceChargeIndex = updatedRenewal.serviceCharges.findIndex(
      (serviceCharge) => serviceCharge.specialChargesKey === specialChargesKey
    );
    updatedRenewal.serviceCharges[serviceChargeIndex] = getUpdatedServiceCharge(
      updatedRenewal.serviceCharges[serviceChargeIndex],
      value
    );
    this.props.onUpdateRenewal(updatedRenewal, submitUpdates);
  }

  submitPriceIncreaseChange() {
    const basePrice = this.state.priceIncreaseValue;
    this.props.handleBasePriceIncrease(basePrice);
  }

  handleApprovalNotesChange(event) {
    const newNotes = event.target.value;
    const originalNotes = this.props.renewal?.adjustmentReason || '';

    this.setState({
      approvalNotes: event.target.value,
      approvalNotesChanged: newNotes !== originalNotes
    });
  }

  handleSaveApprovalNotes() {
    const { approvalNotesChanged } = this.state;
    if (!approvalNotesChanged) return;
    const updatedRenewal = {
      ...this.props.renewal,
      adjustmentReason: {
        adjustmentReasonId: this.props.renewal?.adjustmentReason?.adjustmentReasonId || 0,
        reason: this.state.approvalNotes,
        reasonId: 0
      }
    };
    this.props.onUpdateRenewal(updatedRenewal, false);
//    this.setState({approvalNotesChanged: false});
  }

  handleBackToCustomerList() {
    this.props.history.push(RENEWALS_PORTAL_URL);
  }

  render() {
    const branchRole = getBranchRole(this.props.customer.branchCode);
    const isRenewalStarted = !!this.props.renewal;
    const isRenewalCompleted =
      isRenewalStarted &&
      this.props.renewal.status === RenewalStatus.COMPLETED.name;
    const isRenewalInCoolOff =
      this.props.customer.customerStatus === RENEWAL_COOL_OFF;

    const isReadOnly =
      isRenewalInCoolOff ||
      branchRole === UserType.C3.name ||
      branchRole === UserType.CAM.name ||
      isRenewalCompleted ||
      (isRenewalStarted &&
        this.props.renewal.status ===
          RenewalStatus.CUSTOMER_APPROVAL_REQUIRED) ||
      this.props.customer.contract.hasGeneralPriceListProduct ||
      this.props.customer.contract.hasExcludedProducts ||
      this.props.customer.contract.hasExcludedSRCTypes;

    const showApprovalMessage =
      isRenewalStarted &&
      (this.props.renewal.status === RenewalStatus.IN_PROGRESS.name ||
        this.props.renewal.status === RenewalStatus.APPROVAL_REQUIRED.name) &&
      !!this.props.renewal.validationErrors.length;

    const showPriceIncreaseDropdown =
      !isRenewalStarted &&
      (branchRole === UserType.CSM.name ||
        branchRole === UserType.CSR.name ||
        branchRole === UserType.COM.name ||
        branchRole === UserType.GM.name ||
        branchRole === UserType.RVP.name ||
        branchRole === UserType.RMT.name) &&
      !(this.props.appConfigs['DISABLE_RENEWAL_EDITS']?.value === 'true');

    const showApprovalNotes =
      isRenewalStarted &&
      (this.props.renewal?.status === RenewalStatus.APPROVAL_REQUIRED.name ||
        (this.props.renewal?.status === RenewalStatus.CUSTOMER_APPROVAL_REQUIRED.name &&
          this.state.hadApprovalRequired));

    const canEditApprovalNotes =
      showApprovalNotes &&
      this.props.employeeApprovalTier.includes(
        this.props.customer?.workflowTicket?.currentApprovalTier
      );
    const showTierMismatch =
      isRenewalStarted &&
      this.props.renewal.status === RenewalStatus.APPROVAL_REQUIRED.name &&
      !this.props.employeeApprovalTier.includes(
        this.props.customer?.workflowTicket?.currentApprovalTier
      );
    const nextTopButton =
      !isReadOnly && isRenewalStarted && this.props.canAdvanceRenewal() ? (
        <Button variant="contained" color="primary" onClick={this.props.onNext}>
          {this.props.intl.formatMessage({ id: 'next' })} <Icon>chevron_right</Icon>
        </Button>
      ) : null;

    const nextBottomButton =
      !isReadOnly && isRenewalStarted && this.props.canAdvanceRenewal() ? (
        <Button variant="contained" color="primary" onClick={this.props.onNext}>
          {this.props.intl.formatMessage({ id: 'next' })} <Icon>chevron_right</Icon>
        </Button>
      ) : null;

    const proposeButton = this.props.canPropose() ? (
      <Button
        variant="contained"
        color="primary"
        onClick={() => this.props.handleCreateAgreement(this.props.renewal)}
      >
        {this.props.intl.formatMessage({ id: 'generate_proposal' })} <PictureAsPdfSharpIcon />
      </Button>
    ) : null;

    const closeTopButton =
      !isReadOnly && isRenewalStarted && branchRole !== UserType.CSR.name ? (
        <Button variant="contained" color="primary" onClick={this.props.handleCloseRenewal}>
          {this.props.intl.formatMessage({ id: 'close_renewal' })} <Icon>delete_forever</Icon>
        </Button>
      ) : null;

    const closeBottomButton =
      !isReadOnly && isRenewalStarted && branchRole !== UserType.CSR.name ? (
        <Button variant="contained" color="primary" onClick={this.props.handleCloseRenewal}>
          {this.props.intl.formatMessage({ id: 'close_renewal' })} <Icon>delete_forever</Icon>
        </Button>
      ) : null;

    const backButton = isRenewalStarted ? (
      <Button variant="contained" onClick={this.handleBackToCustomerList}>
        <Icon>chevron_left</Icon> {this.props.intl.formatMessage({ id: 'back' })}
      </Button>
    ) : null;


    const startButton =
      !isRenewalStarted && !isReadOnly ? (
        <Button variant="contained" color="primary" onClick={this.props.handleStartRenewal}>
          {this.props.intl.formatMessage({ id: 'start_renewal', defaultMessage: 'Start Renewal' })}{' '}
          <Icon>play_arrow</Icon>
        </Button>
      ) : null;

    const controlRow = isRenewalStarted ? (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          gap: 8,
          overflow: 'visible',
          marginBottom: 8,
          minWidth: 0
        }}
      >
        <div className="btn-action" style={{ flex: '0 0 auto' }}>
          {backButton}
        </div>
        <div className="btn-action" style={{ flex: '0 0 auto' }}>
          {closeTopButton}
        </div>
        <div
          className="btn-action"
          style={{
            flex: '1 1 auto',
            minWidth: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 8,
            whiteSpace: 'nowrap',
            overflow: 'visible',
            maxWidth: 'none'
          }}
        >
          {proposeButton}
          {nextTopButton}
        </div>
      </div>
    ) : (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          overflow: 'visible',
          marginBottom: 8
        }}
      >
        <div style={{ marginLeft: 'auto' }} className="btn-action">
          {startButton}
        </div>
      </div>
    );

    return (
      <PageBase
        noWrapContent
        navigation={[
          this.props.customer.billToCustomerName.toLowerCase(),
          this.props.intl.formatMessage({ id: 'renewal' })
        ]}
      >
        {controlRow}

        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15 customer-info-row-data">
            <Subheader
              style={{
                fontSize: 24,
                fontWeight: typography.fontWeightLight,
                backgroundColor: '#3e4757',
                color: 'white',
                margin: '20px 0px 0px 0px'
              }}
            >
              {this.props.intl.formatMessage({ id: 'rental_service_agreement' })}
            </Subheader>

            {showTierMismatch && (
              <div
                style={{
                  margin: '8px 0 12px',
                  padding: '10px 12px',
                  borderRadius: 4,
                  background: '#fff3cd',
                  color: '#856404',
                  border: '1px solid #ffeeba'
                }}
              >
                {this.props.intl.formatMessage(
                  {
                    id: 'approval_tier_mismatch_message',
                    defaultMessage:
                      'This renewal requires approval. You do not have permission to act on it.'
                  }
                )}
              </div>
            )}
          </div>
        </div>

        <CustomerHeader
          customer={this.props.customer}
          showPriceIncreaseDropdown={showPriceIncreaseDropdown}
          renewalPriceIncrease={this.state.priceIncreaseValue}
          onPriceChange={this.handlePriceIncreaseChange}
          maxBasePriceIncrease={this.props.appConfigs['MAX_BASE_PRICE_INCREASE']?.value}
        />

        {showApprovalNotes && (
          <div style={{ position: 'relative' }}>
            <ErrorIcon style={{ color: '#f44336', marginRight: 6, marginLeft: 12, float: 'left' }} />
            <label
              htmlFor="approval-notes"
              style={{
                display: 'block',
                fontWeight: 400,
                marginBottom: 8,
                color: '#333',
                fontSize: '16px'
              }}
            >
              Approval Notes
            </label>
            <TextField
              id="approval-notes"
              variant="outlined"
              fullWidth
              multiline
              inputProps={{ maxLength: 4000 }}
              rows={4}
              value={
                this.state.approvalNotes !== null && typeof this.state.approvalNotes === 'object'
                  ? this.state.approvalNotes.reason
                  : this.state.approvalNotes
              }
              onChange={this.handleApprovalNotesChange}
              onBlur={this.handleSaveApprovalNotes}
              disabled={!canEditApprovalNotes}
              InputProps={{
                style: {
                  backgroundColor: '#fff',
                  paddingRight: 100
                }
              }}
            />
{/*
            {canEditApprovalNotes && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={this.handleSaveApprovalNotes}
                disabled={!this.state.approvalNotesChanged}
                style={{
                  position: 'absolute',
                  bottom: 12,
                  right: 12,
                  zIndex: 2
                }}
              >
                {this.props.intl.formatMessage({ id: 'save' })}
              </Button>
            )}
*/}
          </div>
        )}

        {isRenewalStarted &&
        !!this.props.renewal.escalation &&
        !!this.props.renewal.escalation.isEscalated ? (
          <RenewalsEscalationNotePanel
            escalation={this.props.renewal.escalation}
          />
        ) : null}

        {showApprovalMessage ? (
          <RenewalsApprovalRequiredPanel
            validations={getRenewalValidations(
              this.props.renewal,
              this.props.priceReasonCodes,
              this.props.intl
            )}
          />
        ) : null}

        <RenewalLineItemListWrapper
          renewal={this.props.renewal}
          customer={this.props.customer}
          appConfigs={this.props.appConfigs}
        />

        <div className="row" style={{ marginTop: 12, marginBottom: 8 }}>
          <div className="col-xs-12 col-sm-12 col-md-12 btn-action">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
              <div>{closeBottomButton}</div>
              <div>{nextBottomButton}</div>
            </div>
          </div>
        </div>

        <div className="customer-pricing-info-row row" style={{ alignItems: 'flex-start' }}>
          <div className="col-xs-12 col-sm-12 col-md-2">
            {isRenewalStarted ? (
              <RenewalsOptionsPanel
                selectedTerm={this.props.renewal.renewalTermYears}
                disabled={this.props.disabled}
                handleChangeTerm={(value) => {
                  const updated = {
                    ...cloneDeep(this.props.renewal),
                    renewalTermYears: value
                  };
                  this.props.onUpdateRenewal(updated);
                }}
              />
            ) : null}
          </div>

          <div className="col-xs-12 col-md-10">
            <div className="row">
              {isRenewalStarted &&
              this.props.renewal.serviceCharges.length > 0 ? (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7">
                  <RenewalsPricingInfo
                    roundValues
                    renewalStatus={this.props.renewal.status}
                    serviceCharges={this.props.renewal.serviceCharges}
                    updateServiceCharge={this.updateServiceCharge}
                    disabled={this.props.disabled || this.props.appConfigs['DISABLE_RENEWAL_EDITS']?.value === 'true'}
                  />
                </div>
              ) : null}
              {isRenewalStarted &&
              this.props.renewal.emblemCharges.length > 0 ? (
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-5">
                  <EmblemCharges
                    emblemCharges={this.props.renewal.emblemCharges}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </PageBase>
    );
  }
}

RenewalProductListPage.propTypes = {
  renewal: PropTypes.object,
  customer: PropTypes.object.isRequired,
  onUpdateRenewal: PropTypes.func,
  onNext: PropTypes.func,
  handleStartRenewal: PropTypes.func,
  handleCloseRenewal: PropTypes.func,
  canAdvanceRenewal: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  priceReasonCodes: PropTypes.array,
  canPropose: PropTypes.func.isRequired,
  employeeApprovalTier: PropTypes.array,
  history: PropTypes.object.isRequired
};

export default withRouter(injectIntl(RenewalProductListPage));